<mat-card class="accion-emergencia-dialog selector-mapa-emergencia">
  <app-card-header
    title="Rumbo a hospital"
    subtitle="Elegí el hospital al que va la ambulancia"
    icono="local_hospital"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  @if (cargando) {
    <section class="inputs-group">
      <app-loading text="Cargando hospitales…" [diameter]="60"></app-loading>
    </section>
  } @else {
    <div class="selector-mapa-cuerpo card-content-crear">
      <div class="selector-mapa-mapa">
        @if (mapCardConfig) {
          <app-map-card
            [config]="mapCardConfig"
            style="height: 100%; width: 100%"
            (entityClick)="onMarkerClick($event)"
          ></app-map-card>
        }
      </div>

      <div class="selector-mapa-lista">
        <div class="selector-mapa-grupo">
          Hospitales
          <span class="selector-mapa-cuenta">{{ hospitales.length }}</span>
        </div>
        @for (hospital of hospitales; track hospital._id) {
          <button
            type="button"
            class="selector-mapa-item irx-sin-estilo"
            [attr.aria-pressed]="hospital._id === hospitalSeleccionado?._id"
            [class.actual]="hospital._id === idHospitalActual"
            (click)="seleccionar(hospital)"
          >
            <span class="material-icons" style="font-size: 18px; opacity: 0.7">
              local_hospital
            </span>
            <span class="selector-mapa-texto">
              <span class="selector-mapa-nombre">
                {{ hospital.identificacion }}
              </span>
              @if (hospital.valores?.gestion) {
                <span class="movil-detalle">
                  {{ hospital.valores?.gestion }}
                </span>
              }
            </span>
            @if (hospital.distancia !== undefined) {
              <span class="selector-mapa-dist">
                {{ distanciaFormateada(hospital.distancia) }}
              </span>
            }
          </button>
        } @empty {
          <span class="no-info">Sin hospitales cargados</span>
        }
      </div>
    </div>
  }

  <mat-card-actions class="actions-create">
    <app-button
      matType="mat-fab extended"
      color="neutral"
      text="Cancelar"
      icon="close"
      (click)="cerrar()"
    ></app-button>
    <app-button
      matType="mat-fab extended"
      color="primary"
      text="Ir a este hospital"
      icon="local_hospital"
      [disabled]="!hospitalSeleccionado"
      (click)="confirmar()"
    ></app-button>
  </mat-card-actions>
</mat-card>
